import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { FieldType, FormlyField } from '@ngx-formly/core';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { PreviewSelectionComponent } from '../helper/preview/preview.component';

@Component({
  selector: 'kt-formly-field-expansion',
  templateUrl: './expansion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyField, MatChipsModule, MatExpansionModule, NgIf, PreviewSelectionComponent],
})
export class FormlyFieldExpansionComponent extends FieldType {
  showSelected(options: FormlySelectOption[], selected: unknown[]) {
    return options.filter(o => selected?.includes(o.value));
  }
}
